import styled, { css } from 'styled-components';
import { Divider } from 'antd';
import {
  ContentContainer,
  UnderlineLink,
  DataValue as CommonDataValue,
  DataHeading,
} from '../../../../CommonComponents/commonStyles';
import { CommonCard } from '../../../../CommonComponents/commonStyles';

export const ContributionGreyBackgroundSection = styled.div`
  background-color: ${(props) => props.theme.backgroundColor.layoutDark};
  padding: 50px 0px;
  @media only screen and (max-width: 576px) {
    padding: 40px 0px;
  }
`;

export const CommonCardContributions = styled(CommonCard)`
  /* text-transform: capitalize; */
`;

const fontCommonStyle = css`
  font-family: HelveticaNeue;
  font-size: 16px;
  color: #505050;
`;

export const NoChange = styled.div`
  ${fontCommonStyle};
  line-height: 1.13;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-left: 7px;
  }
`;

export const MarginBottom = styled.div`
  margin-bottom: 60px;
`;

export const NoChangeSpace = styled(NoChange)`
  margin-bottom: 45px;
  width: 236px;
  display: flex;
  margin-top: -3.25rem;
  justify-content: space-between;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 20px;
    margin-left: 0;
  }
`;

export const ContributionsDashBoardBody = styled.div`
  margin-bottom: -24px;
`;

export const ContributionMargin = styled.div`
  margin-bottom: 20px;
`;

export const ContributionHead = styled.p`
  letter-spacing: ${(props) => props.theme.letterSpacing.normal};
  color: ${(props) => props.theme.fontColors.headingColor};
  font-family: ${(props) => props.theme.fontFamily.berkeleyStd};
  font-weight: ${(props) => props.theme.fontWeight.normal};
  font-size: ${(props) => props.theme.fontSize.h2};
  line-height: ${(props) => props.theme.lineHeight.normal};
  margin-bottom: 0.5rem;
`;

export const ActivityHead = styled(ContributionHead)`
  display: inline-block;
  vertical-align: sub;
`;

export const HeadActivity = styled(ActivityHead)`
  font-size: ${(props) => props.theme.fontSize.h2};
  letter-spacing: ${(props) => props.theme.letterSpacing.normal};
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    font-size: ${(props) => props.theme.fontSize.h3};
  }
`;

export const DateNow = styled.p`
  color: ${(props) => props.theme.fontColors.textColor};
  font-size: ${(props) => props.theme.fontSize.primary};
  font-weight: ${(props) => props.theme.fontWeight.normal};
  line-height: ${(props) => props.theme.lineHeight.normal};
  letter-spacing: ${(props) => props.theme.lineHeight.normal};
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  margin-bottom: 0;
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    font-size: ${(props) => props.theme.fontSize.secondary};
  }
`;

export const DataDescription = styled.div`
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  font-size: ${(props) => props.theme.fontSize.primary};
  font-weight: ${(props) => props.theme.fontWeight.normal};
  font-stretch: ${(props) => props.theme.fontStretch.normal};
  line-height: ${(props) => props.theme.lineHeight.normal};
  letter-spacing: ${(props) => props.theme.letterSpacing.normal};
  color: #505050;
  margin: 12px 0 0 0;
  @media only screen and (max-width: 990px) {
    font-size: ${(props) => props.theme.fontSize.secondary};
    line-height: ${(props) => props.theme.lineHeight.secondary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${(props) => props.theme.fontSize.secondary};
    line-height: ${(props) => props.theme.lineHeight.secondary};
  }
`;

export const DataValue = styled(CommonDataValue)`
  font-weight: ${(props) => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${(props) => props.theme.fontStretch.normal};
  line-height: ${(props) => props.theme.lineHeight.primary};
  letter-spacing: ${(props) => props.theme.letterSpacing.zero};
  color: ${(props) =>
    props.dashboard
      ? props.theme.fontColors.headingColor
      : props.theme.fontColors.textColor};
  //margin-top: 0.375rem;
  @media only screen and (max-width: 990px) {
    font-size: ${(props) => props.theme.fontSize.secondary};
    line-height: ${(props) => props.theme.lineHeight.secondary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${(props) => props.theme.fontSize.secondary};
    line-height: ${(props) => props.theme.lineHeight.secondary};
  }
`;

export const UnderlineLinkContributions = styled(UnderlineLink)`
  color: ${(props) =>
    props.reversed ? '#505050' : props.theme.fontColors.primary} !important;
  text-decoration: ${(props) => (props.reversed ? 'none' : 'underline')};
  pointer-events: ${(props) => (props.reversed ? 'none' : 'all')};
  &:hover :focus {
    color: ${(props) =>
      props.reversed ? '#505050' : props.theme.fontColors.primary} !important;
    text-decoration: ${(props) => (props.reversed ? 'none' : 'underline')};
  }
  a {
    color: ${(props) =>
      props.reversed ? '#505050' : props.theme.fontColors.primary} !important;
    text-decoration: ${(props) => (props.reversed ? 'none' : 'underline')};
  }
  ${({ wid30 }) => (wid30 ? `min-width:30%;` : `min-width:none;`)}
`;

export const UnderlineLinkTxn = styled(UnderlineLinkContributions)`
  font-family: ${(props) =>
    props.theme.fontFamily.berkeleyStdMedium} !important;
`;

export const DashboardDivider = styled(Divider)`
  width: 96%;
  margin: 10px auto;
`;

export const DataHeadingMobile = styled(DataHeading)`
  display: inline-block;
`;

export const DataValueMobile = styled(DataValue)`
  display: inline-block;
`;

export const MarginWrapper = styled.div`
  margin-top: 75px;
`;

export const ContentContainerSpace = styled(ContentContainer)`
  padding: 2.75rem 9% 0 9%;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding: 2.75rem 6.4% 0 6.1%;
  }
`;

export const NameHeading = styled(DataHeading)`
  display: inline-block;
  margin-top: 1.25rem;
  letter-spacing: ${(props) => props.theme.letterSpacing.zero};
  & b {
    color: ${(props) => props.theme.fontColors.headingColor};
  }
`;

export const ActivityText = styled.p`
  font-size: 16px;
  color: #505050;
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  @media only screen and (min-width: 320px) and (max-width: 720px) {
    font-size: 14px;
  }
`;

export const DateNowIn = styled.p`
  margin-bottom: 0;
  width: auto;
  height: 24px;
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  font-size: ${(props) => props.theme.fontSize.primary};
  line-height: ${(props) => props.theme.lineHeight.primary};
  letter-spacing: ${(props) => props.theme.letterSpacing.normal};
  color: ${(props) => props.theme.fontColors.textColor};
`;

export const ChartData = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: '100%';
  height: '100%';
  margin: 'auto';
  font-family: ${(props) => props.theme.fontFamily.helveticaNeueBold};
  color: ${(props) => props.theme.fontColors.textColor};
`;
